const ExportTypes = {
  RECEPTION: "RECEPTION",
  REFCREATION: "REFCREATION",
};

export default ExportTypes;
